import { HashRouter, Outlet, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";
import { NotificationsPage } from "./pages/NotificationsPage";
import { ExplorePage } from "./pages/ExplorePage";
import { MessagesPage } from "./pages/MessagesPage";
import { ListFeedPage } from "./pages/ListFeedPage";
import { CommunityPage } from "./pages/CommunityPage";
import { HashtagFeedPage } from "./pages/HashtagFeedPage";
import { SettingsPage } from "./pages/SettingsPage";
import { MediaPlayerPage } from "./pages/MediaPlayerPage";
import { MainLayout } from "./components/layout/MainLayout";

/**
 * Shared layout route.
 *
 * MainLayout (sidebar, relay monitor, audio bar) mounts once here and stays
 * mounted while the nested page swaps via <Outlet/>. Previously every route
 * wrapped its own <MainLayout> copy, so the whole shell remounted on every
 * navigation — making page transitions visibly slower and re-initializing
 * every sidebar query.
 */
function AppLayout() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}

export function AppRouter() {
  return (
    <HashRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Index />} />

          <Route path="/notifications" element={<NotificationsPage />} />

          <Route path="/explore" element={<ExplorePage />} />

          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/messages/:recipient" element={<MessagesPage />} />

          {/* User-configured sidebar lists */}
          <Route path="/list/:id" element={<ListFeedPage />} />

          {/* NIP-72 communities */}
          <Route path="/community/:addr" element={<CommunityPage />} />

          {/* Hashtag feeds */}
          <Route path="/t/:tag" element={<HashtagFeedPage />} />

          {/* App settings */}
          <Route path="/settings" element={<SettingsPage />} />

          {/* Dedicated media player page */}
          <Route path="/player/:id?" element={<MediaPlayerPage />} />

          {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
          <Route path="/:nip19" element={<NIP19Page />} />

          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
}
export default AppRouter;
